
$(document).on('click', 'a[href^="#"]:not(.cookie-submit-button)', function (event) {
    event.preventDefault();
if (typeof event.target !== 'undefined') {
   $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
}
});

// OO-17017 - with brcmpgid param switch installer path
(function(){
	'use strict';

	var unserialize = avm.require('avast.url.unserialize'),
		linkDecorator = avm.require('avast.web.linkDecorator'),
		$ = avm.require('jquery'),
		qs = unserialize(),
		productId = 'SBR',
		productIdCid = 'SBR-CID',
		re = /^[a-z0-9]+$/i;

	if (qs && qs.brcmpgid && re.test(qs.brcmpgid)){

		if ('URLSearchParams' in window) {
			document.querySelectorAll('[data-download-name="' + productId + '"]').forEach(function(el) {
				var downloadURL, downloadQueryString;

				if (el.href) {
					downloadURL = new URL(el.href)
					downloadQueryString = new URLSearchParams(downloadURL.search)
				
					downloadQueryString.set('product', productIdCid)
					downloadQueryString.set('tag', qs.brcmpgid)

					downloadURL.search = downloadQueryString.toString();
					el.href = downloadURL.toString();				
				}
			})
		} else {
			// Internet Explorer fallback
			$('[data-download-name="' + productId + '"]').each(function(){
				var el = this,
					href,
					downloadQueryString;
				
				downloadQueryString = el.search
				href = el.href.replace(downloadQueryString, '');

				el.href = href + downloadQueryString.replace('=' + productId + '&', '=' + productIdCid + '&');

				linkDecorator(el, 'tag', 'tag=null', qs.brcmpgid);
			});
		}
	}
})();


// OO-17619 - initialize avast.web.tabsAnchor module
(function() {
	'use strict';
	var tabsAnchor = avm.require('avast.web.tabsAnchor');
	tabsAnchor.init('#tabs-anchor');
})();
// /OO-17619
